
import { ErrorMessage, Field, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import apiZelo from '../../../services/backAxiosVendaToken';

export const FormPet = props => {

    const PlanosPrime = [
        'ZP', 'ZPA', 'ZP4', 'ZPC', 'ZPCA', 'ZPC4'
    ];
    const [tipoPet, setTipoPet] = useState([]);
    const [portePet, setPortePet] = useState([
        {
            Codigo: 1,
            Descricao: 'Pequeno - Até 29 kg'
        },
        {
            Codigo: 2,
            Descricao: 'Médio - 30 a 49 kg'
        },
        {
            Codigo: 3,
            Descricao: 'Grande - Acima de 50 kg'
        }
    ]);
    const [showPetForm, setShowPetForm] = useState(false);

    const {
        values: { Parentesco, Plano }, setFieldValue
    } = useFormikContext();

     const verificaPlano = plano => {
        const planoPrimeEncontrado = PlanosPrime.find(itemPlano => itemPlano === plano);
    
        return planoPrimeEncontrado !== undefined ? true : false;
    };

    useEffect(() => {
        if (verificaPlano(Plano)) {
            setPortePet([
                {
                    Codigo: 1,
                    Descricao: 'Pequeno - Até 20 kg'
                }
            ]);
        }
        if (Parentesco !== 'PET') {
            return;
        } else {
            (async () => {
                const { data } = await apiZelo.get('/produtos/pet/tipos/todos');

                setTipoPet(data);
            })();

            if (!showPetForm) {
                setShowPetForm(true);
            }
        }

        return () => {
            setFieldValue('TipoPet', '');
            setFieldValue('CorPet', '');
            setFieldValue('Porte', '');
            setFieldValue('PesoPet', '');
            setFieldValue('CaracteristicasPet', '');
        };
    }, [Parentesco, showPetForm]);

    return <>
        {Parentesco === 'PET' &&
            <Fieldset legend='Dados Pet' className='form-ocupar-todo-espaco'>
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-4">
                        <Field
                            as={Dropdown}
                            dataKey="Codigo"
                            name="TipoPet"
                            id="TipoPet"
                            optionLabel="Nome"
                            optionValue="Codigo"
                            options={tipoPet}
                            placeholder="Tipo do pet"
                        />
                        <ErrorMessage
                            component="span"
                            name="TipoPet"
                            style={{ color: 'red' }}
                        />
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Field
                            as={InputText}
                            name="CaracteristicasPet"
                            type="text"
                            id="CaracteristicasPet"
                            placeholder="Raça"
                            onChange={e => setFieldValue('CaracteristicasPet', e.target.value.toUpperCase())}
                        />
                        <ErrorMessage
                            component="span"
                            name="CaracteristicasPet"
                            style={{ color: 'red' }}
                        />
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Field
                            as={InputNumber}
                            name="PesoPet"
                            id="PesoPet"
                            placeholder="Peso"
                        />
                        <ErrorMessage
                            component="span"
                            name="PesoPet"
                            style={{ color: 'red' }}
                        />
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Field
                            as={InputText}
                            name="CorPet"
                            id="CorPet"
                            placeholder="Cor"
                        />
                        <ErrorMessage
                            component="span"
                            name="CorPet"
                            style={{ color: 'red' }}
                        />
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Field
                            as={Dropdown}
                            dataKey="Codigo"
                            name="Porte"
                            id="Porte"
                            optionLabel="Descricao"
                            optionValue="Codigo"
                            options={portePet}
                            placeholder="Porte pet"
                        />
                        <ErrorMessage
                            component="span"
                            name="Porte"
                            style={{ color: 'red' }}
                        />
                    </div>
                </div>
            </Fieldset>
        }
    </>;
};
